var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("image", {
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAACVklEQVRYw+2WL3TiQBDGfyICgYhAICIqKioRCATi3juJQCAqEAhkBeIEIqICWYGoQCBOICMQCETFiQgEoqKiAoFAIBCIEwgEJ5JsQ3Y32aQn7t7rrOHNTL5hv51/8CX/hzj0mTBnxZYtPh7PdKn8DWgbF5+L8px5YUCpOHiJIUcN+MfZ08cqAt9ilwkenXcaeeFdY/CIrp45eJlZTvjgPJlS5RWCD0IYyKPiQ/PXyCSqo/johMPa+C0a6Vl/0FzcYW+cUSkvMVLmuQ3AnTFRfR18lZPCvR2zr4wC7HXVPc7MC4snzgYhBuoAG8lxruCzzq/MAC8q+Jrk5mkbWRNPSedHLlWym8Mkoy7L3DPGj2XXhgXv4e+u/MEiBn7gvmAHHoYIz7JpLa738xOjpCXolSTK8ttPDajbEMWXTRE9snyjrgRT6W9ClK1pAIs3LlxYGuod0R4libKhqml+dSN9I9Su5ACvoal2pe0JoO9G+rYoUUmWoamTGPxBf32TFgK1/oeoIm0nnUlQPTqKolPrfX1HbYamY7ElBICKIM5RmXdSg84rA30VAExFTyl2B1usaa6uCs9ZMylVRoJkW+cyES53ueGb4u8N9U5VfovRbeeCvxGFuktfhx9EHvg5QjhiDlxoZTlPYwuIGVGN2NBxs92t2Mw9Zq7mJYax4Tkzu3D1aqxvaGuClOhdrWMeZVNOrRhRwU1mdKiFndahTpe5SIjgPOZNu4cEQNo5JFokplRNDNasE6OcKZ2o7mnKTrphnBhQBaXJiCWv4ZPuWLPATYymL/ln5Q8uorZOsTOFJAAAAABJRU5ErkJggg=="
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "planning_blck",
    "data-name": "planning blck",
    width: 33,
    height: 33,
    fill: "url(#pattern)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMain);
export default __webpack_public_path__ + "static/media/user_main.3afd732183008880f4b1e918028de59a.svg";
export { ForwardRef as ReactComponent };